export const GST_NUMBER_ERROR = 'Enter a valid 15 character GST number.';

export const normalizeGstNumber = (value) => (value ?? '').trim().toUpperCase();

// Match the checkout API's format check; GST remains optional.
export const isValidCheckoutGst = (value) => {
    const gst = normalizeGstNumber(value);
    return gst === '' || /^[0-9A-Z]{15}$/.test(gst);
};
